import PaymentMode from '@/shared/enums/PaymentMode'

export const METHOD_LABELS: Record<PaymentMode, string> = {
    [PaymentMode.creditCard]: 'Credit Card',
    [PaymentMode.bankSlip]: 'Boleto',
    [PaymentMode.debitCard]: 'Debit Card',
    [PaymentMode.pix]: 'PIX',
    [PaymentMode.oxxo]: 'OXXO',
    [PaymentMode.paynet]: 'Paynet',
    [PaymentMode.tiendasYFarmacias]: 'Tiendas y Farmacias',
    [PaymentMode.spei]: 'SPEI',
    [PaymentMode.paycash]: 'PayCash',
    [PaymentMode.picpay]: 'PicPay',
    [PaymentMode.bankTransfer]: 'Bank Transfer',
    [PaymentMode.pagoEfectivo]: 'Pago Efectivo',
    [PaymentMode.deuna]: 'Deuna',
    [PaymentMode.nequi]: 'Nequi',
    [PaymentMode.mach]: 'Mach',
    [PaymentMode.qrInteroperable]: 'QR · Yape, Plin y bancos',
    [PaymentMode.breb]: 'Bre-B',
}

export const SHORT_LABELS: Record<PaymentMode, string> = {
    [PaymentMode.creditCard]: 'CC',
    [PaymentMode.bankSlip]: 'BOLETO',
    [PaymentMode.debitCard]: 'DEBIT',
    [PaymentMode.pix]: 'PIX',
    [PaymentMode.oxxo]: 'OXXO',
    [PaymentMode.paynet]: 'PAYNET',
    [PaymentMode.tiendasYFarmacias]: 'TYF',
    [PaymentMode.spei]: 'SPEI',
    [PaymentMode.paycash]: 'PAYCASH',
    [PaymentMode.picpay]: 'PICPAY',
    [PaymentMode.bankTransfer]: 'BANK',
    [PaymentMode.pagoEfectivo]: 'PAGO',
    [PaymentMode.deuna]: 'DEUNA',
    [PaymentMode.nequi]: 'NEQUI',
    [PaymentMode.mach]: 'MACH',
    [PaymentMode.qrInteroperable]: 'QR',
    [PaymentMode.breb]: 'Bre-B',
}

const [appBrand] = process.env.VUE_APP_NAME.split('-')
const METHOD_IMAGES: Partial<Record<PaymentMode, string>> = {
    [PaymentMode.creditCard]: require(`@/checkout/assets/card-brand/credit-card-${appBrand}.png`),
    [PaymentMode.debitCard]: require(`@/checkout/assets/card-brand/debit-card-${appBrand}.png`),
    [PaymentMode.bankSlip]: require(`@/checkout/assets/card-brand/bar-code-${appBrand}.png`),
    [PaymentMode.picpay]: require('@/checkout/assets/card-brand/picpay.png'),
    [PaymentMode.pix]: require('@/checkout/assets/card-brand/pix.png'),
    [PaymentMode.oxxo]: require('@/checkout/assets/card-brand/oxxo.png'),
    [PaymentMode.paynet]: require('@/checkout/assets/card-brand/paynet.png'),
    [PaymentMode.tiendasYFarmacias]: require(`@/checkout/assets/card-brand/tiendas-y-farmacias-${appBrand}.png`),
    [PaymentMode.spei]: require('@/checkout/assets/card-brand/spei.png'),
    [PaymentMode.paycash]: require('@/checkout/assets/card-brand/paycash.png'),
    [PaymentMode.bankTransfer]: require(`@/checkout/assets/card-brand/bank-transfer-${appBrand}.png`),
    [PaymentMode.pagoEfectivo]: require('@/checkout/assets/card-brand/pago-efectivo.png'),
    [PaymentMode.deuna]: require('@/checkout/assets/card-brand/deuna.png'),
    [PaymentMode.nequi]: require('@/checkout/assets/card-brand/nequi.png'),
    [PaymentMode.mach]: require('@/checkout/assets/card-brand/mach.png'),
    [PaymentMode.qrInteroperable]: require(`@/checkout/assets/card-brand/qr-code-${appBrand}.png`),
    [PaymentMode.breb]: require('@/checkout/assets/card-brand/breb.png'),
}

export function isCardMethod(method: PaymentMode): boolean {
    return method === PaymentMode.creditCard || method === PaymentMode.debitCard
}

export function methodLabel(method: PaymentMode): string {
    return METHOD_LABELS[method] ?? method
}

export function methodShortLabel(method: PaymentMode): string {
    return SHORT_LABELS[method] ?? method
}

export function methodImage(method: PaymentMode): string | null {
    return METHOD_IMAGES[method] ?? null
}

export function hasMethodImage(method: PaymentMode): boolean {
    return method in METHOD_IMAGES
}
